import { useState } from "react";
import { FetchResult, gql, useMutation } from "@apollo/client";
import { useToast } from "@/hooks/use-toast";

const UPDATE_FIGURES_MUTATION = gql`
  mutation UpdateKeyFigureMutation($securityCode: String, $keyFigures: String) {
    importSecurities(
      securityList: [{ securityCode: $securityCode, keyFigures: $keyFigures }]
    )
  }
`;

interface importKeyFiguresQueryVariables {
  securityCode: string;
  keyFigures: string;
}

const errorStatus = "ERROR" as const;

interface importKeyFiguresQueryResponse {
  importSecurities: ({
    importStatus: "OK" | typeof errorStatus;
  } & unknown)[];
}

export const useUpdatePollData = () => {
  const [submitting, setSubmitting] = useState(false);
  const { toast } = useToast();
  const [handleUpdatePollData] = useMutation<
    importKeyFiguresQueryResponse,
    importKeyFiguresQueryVariables
  >(UPDATE_FIGURES_MUTATION);

  const updatePollDataz = async (
    securityCode: string,
    keyFigures: string,
    callback?: () => void
  ) => {
    console.log(securityCode, keyFigures);
    return false;
  };
  const updatePollData = async (
    securityCode: string,
    keyFigures: string,
    callback?: () => void
  ) => {
    setSubmitting(true);
    try {
      const apiResponse = await handleUpdatePollData({
        variables: { securityCode, keyFigures },
      });
      handleBadAPIResponse(apiResponse);
      setSubmitting(false);
      callback && callback();
      return apiResponse;
    } catch (e: unknown) {
      toast({
        title: "Error updating poll data",
        description: "An error occurred while updating poll data",
        variant: "destructive",
      });
      setSubmitting(false);
      return null;
    }
  };

  return { updatePollData, submitting };
};

//***:cqcsContactNotes=2024-12-16=testingTesting2

const handleBadAPIResponse = (
  apiResponse: FetchResult<
    importKeyFiguresQueryResponse,
    Record<string, unknown>,
    Record<string, unknown>
  >
) => {
  if (!apiResponse.data || !apiResponse.data.importSecurities) {
    throw new Error("Invalid API response: missing data or importSecurities");
  }
};
